import React from "react";
import { TrendingUp, ShieldCheck, Eye } from "lucide-react";

const ABOUT_IMG =
  "https://images.pexels.com/photos/30131051/pexels-photo-30131051.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";

const MISSIONS = [
  { icon: TrendingUp, label: "Grow Influence" },
  { icon: ShieldCheck, label: "Protect Reputation" },
  { icon: Eye, label: "Deliver Strategic Intelligence" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-black text-white py-24 md:py-32 lg:py-40 border-t border-zinc-900"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Image */}
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] w-full overflow-hidden border border-zinc-900">
              <img
                src={ABOUT_IMG}
                alt="Classical pillars"
                className="absolute inset-0 w-full h-full object-cover grayscale"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-300">
                01 · The Firm
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-zinc-600" />
              <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-zinc-400">
                Who We Are
              </span>
            </div>

            <h2
              data-testid="about-headline"
              className="font-display font-light uppercase leading-[1] tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl"
            >
              More Than a<br />
              Marketing Agency
            </h2>

            <p className="mt-10 max-w-2xl font-sans text-base md:text-lg leading-relaxed text-zinc-400">
              CAMO is a private digital operations firm providing growth,
              intelligence and protection services through a subscription-based
              model.
            </p>

            <div className="mt-12 pt-8 border-t border-zinc-900">
              <span className="font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-500">
                Our Mission
              </span>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-6">
                {MISSIONS.map(({ icon: Icon, label }, i) => (
                  <div
                    key={label}
                    data-testid={`mission-item-${i}`}
                    className="flex items-start gap-4 p-5 border border-zinc-900 hover:border-zinc-600 transition-colors duration-300"
                  >
                    <Icon size={22} strokeWidth={1} className="text-white shrink-0 mt-0.5" />
                    <span className="font-display text-lg md:text-xl leading-tight text-white">
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
